import React, { memo, Suspense, useState } from 'react';
import { useDispatch } from 'react-redux';
import useFetchParts from '../../hooks/parts/useFetchParts';
import { setSelectedPartAction } from '../../redux/actions/partsActions';
import CommonLoader from '../shared/loaders/CommonLoader';
import EmptyContent from '../shared/table/EmptyContent';
import DeletePartModal from './modals/DeletePartModal';
import UpdatePartModal from './modals/UpdatePartModal';
import PartsTable from './PartsTable';

const PartsList = ({ readOnly }) => {
  const dispatch = useDispatch();
  const { loading, parts, refresh } = useFetchParts({ unpaged: false });
  const [showUpdatePartModal, setShowUpdatePartModal] = useState(false);
  const [showDeletePartModal, setShowDeletePartModal] = useState(false);

  const handlePartClick = (part) => {
    dispatch(setSelectedPartAction(part));
    setShowUpdatePartModal(true);
  };

  const handleUpdatePartModalSubmit = async () => {
    refresh();
    setShowUpdatePartModal(false);
  };

  const handlePartDeleteClick = (part) => {
    dispatch(setSelectedPartAction(part));
    setShowDeletePartModal(true);
  };

  const handleDeletePartModalSubmit = async () => {
    refresh();
    setShowDeletePartModal(false);
  };

  return (
    <Suspense fallback={<CommonLoader />}>
      <div className="flex flex-col items-center">
        {showUpdatePartModal && (
          <UpdatePartModal
            readOnly={readOnly}
            onModalSubmit={() => handleUpdatePartModalSubmit()}
            onModalClose={() => setShowUpdatePartModal(false)}
          />
        )}
        {showDeletePartModal && (
          <DeletePartModal
            onModalSubmit={() => handleDeletePartModalSubmit()}
            onModalClose={() => setShowDeletePartModal(false)}
          />
        )}
        <>
          <PartsTable
            onPartClick={handlePartClick}
            onPartDeleteClick={handlePartDeleteClick}
            parts={parts}
            readOnly={readOnly}
            loading={loading}
          />
          {parts.length === 0 && !loading && <EmptyContent title={'Список запчастин порожній'} />}
        </>
      </div>
    </Suspense>
  );
};

export default memo(PartsList);
